import React, { useState } from "react";
import { Box } from "./style";

/**
 * Make float label input with warning .
 * @param {String} status
 * @param {String} icon
 * @param {String} type
 * @param {String} label
 * @param {String} notice
 */
export default props => {
  const [iconStatus, setIconStatus] = useState("");
  const labelStatus = () => {
    if (props.input.value && props.input.value.toString().length > 0) {
      return "top";
    } else {
      return "down";
    }
  };
  const formStatus = () => {
    if (props.meta.error) {
      return "error";
    }
  };
  return (
    <Box
      status={formStatus()}
      iconStatus={iconStatus}
      labelStatus={labelStatus()}
    >
      <input
        id={props.id || props.input.name}
        type={props.type}
        value={props.input.value}
        onChange={e => props.input.onChange(e.target.value)}
        onFocus={() => setIconStatus("focus")}
        onBlur={() => setIconStatus("")}
        autoComplete="random"
        maxLength={props.input.maxLength}
        {...props}
      />
      <i className={props.icon} />
      <label htmlFor={props.id || props.input.name}>{props.label}</label>
      <span className="notice">{props.meta.error}</span>
    </Box>
  );
};
